import React from 'react';
import PageHeader from '../shared/page-header';

// Map Creator's registration screen links to this page, at https://fmosoft.com/privacy.
// When the policy changes, update the date below.
const Privacy = () => {
    const styles = {
        updated: {
            fontStyle: 'italic',
        },
        heading: {
            marginTop: 30,
        },
    };

    return (
        <div>
            <PageHeader><span>Map Creator Privacy Policy</span></PageHeader>
            <div className="row">
                <div className="col-md-8 col-md-offset-2">
                    <p style={styles.updated}>Last updated: October 23, 2026</p>
                    <p>Map Creator is made by FMOsoft. This policy explains what information Map Creator sends to FMOsoft, why, and what you can ask us to do with it. If you have a question, email <a href="mailto:help@fmosoft.com">help@fmosoft.com</a>.</p>

                    <h3 style={styles.heading}>Map Creator works without registering</h3>
                    <p>You don’t have to register to use Map Creator. Every feature works whether or not you register. Map Creator contacts fmosoft.com only to send a registration, and only after you choose to register.</p>

                    <h3 style={styles.heading}>What a registration contains</h3>
                    <p>When you register, Map Creator sends:</p>
                    <ul>
                        <li>Map Creator’s version, and the language its menus are in.</li>
                        <li>Your computer’s operating system and its version number, such as “Windows 11 Version 25H2”, and its type of processor.</li>
                        <li>The country you choose, or “Other” if you’d rather not say.</li>
                        <li>Your organization, if you enter one.</li>
                        <li>A random installation number that Map Creator creates. It doesn’t come from your computer or from you. It lets us count you once even if you register again, for example after updating Map Creator.</li>
                    </ul>
                    <p>A registration sent over the internet doesn’t include your name or your email address.</p>
                    <p>Map Creator 2.3.2 and earlier also ask for your name and email address when you register, and send your country, a purchase key, and a description of your computer that includes its amount of memory.</p>
                    <p>If you register by email instead, we also receive your email address and anything else in the email you send, such as your name if your email program adds it.</p>
                    <p>Like most websites, fmosoft.com’s web server records the internet (IP) address of each request in its technical logs. We don’t store it with your registration.</p>

                    <h3 style={styles.heading}>Why we collect it</h3>
                    <p>We use registrations to learn how many people use Map Creator and in which countries, and which languages and computers they use. That helps us decide where to focus our work, such as which translations to add. When you register by email, we also use your email address to reply with your registration code.</p>
                    <p>We don’t sell or share registrations, use them for advertising, or add you to a mailing list.</p>

                    <h3 style={styles.heading}>Where it’s kept</h3>
                    <p>Registrations are stored in FMOsoft’s database, and only the FMOsoft team can see them. The team is told about each new registration by email. Registrations sent by email, our replies, and those messages to the team pass through Amazon Web Services’ email and notification services. We keep registrations so we can see how Map Creator’s use changes over time.</p>
                    <p>FMOsoft’s server and database are in the United States, so if you register from another country, your registration is sent to and stored in the United States.</p>
                    <p>Registrations from Map Creator 2.3.2 and earlier are kept the same way.</p>

                    <h3 style={styles.heading}>Seeing, correcting or deleting your registration</h3>
                    <p>You can ask us what we have from you, ask us to correct it, or ask us to delete it, by emailing <a href="mailto:help@fmosoft.com">help@fmosoft.com</a>. We’ll answer as soon as we can.</p>
                    <ul>
                        <li>For a registration you sent by email, or from Map Creator 2.3.2 or earlier, write from the same email address, so we can find it.</li>
                        <li>A registration sent over the internet has no name or email address, so tell us your country, your organization if you entered one, and roughly when you registered, and we’ll find it as best we can.</li>
                    </ul>
                    <p>If you live in the European Union or the United Kingdom, you register by choice, and you can withdraw that choice by asking us to delete your registration. You can also complain to your country’s data protection authority.</p>

                    <h3 style={styles.heading}>Changes</h3>
                    <p>If we change this policy, we’ll update it here and change the date at the top.</p>
                </div>
            </div>
        </div>
    );
};
Privacy.propTypes = {};

export default Privacy;
